import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";


export const store = configureStore({
  reducer: rootReducer,
 
/*   middleware: getDefaultMiddleware({
    serializableCheck: {
      // Ignore actions that contain these paths
      ignoredActionPaths: ["payload.headers"],
      // Ignore these field paths in the state
      ignoredPaths: ["some.nested.path.to.ignore"],
    },
  }), */
});
